<div class="filter">
  <app-user-is-external-dropdown
    [value]="userType()"
    (selectionChange)="userType.set($event)"
    color="primary"
    appearance="outline"
    subscriptSizing="dynamic"
    class="stretch-mobile"
  />
  <app-search-input (keyupp)="search.set($event)" color="primary" appearance="outline" class="stretch-mobile" subscriptSizing="dynamic" />
</div>

<app-table-container>
  <table mat-table matSort [dataSource]="dataSource" class="app-table">
    <ng-container matColumnDef="firstName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'admin.user-management.first-name' | translate }}</th>
      <td mat-cell *typeSafeMatCellDef="let row; dataSource: dataSource">{{ row.firstName }}</td>
    </ng-container>
    <ng-container matColumnDef="lastName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'admin.user-management.last-name' | translate }}</th>
      <td mat-cell *typeSafeMatCellDef="let row; dataSource: dataSource">{{ row.lastName }}</td>
    </ng-container>
    <ng-container matColumnDef="account">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'admin.user-management.account' | translate }}</th>
      <td mat-cell *typeSafeMatCellDef="let row; dataSource: dataSource">
        {{ (row.isInternal ? 'admin.user-management.internal' : 'admin.user-management.external') | translate }}
      </td>
    </ng-container>
    <ng-container matColumnDef="organization">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'admin.user-management.organization-unit' | translate }}</th>
      <td mat-cell *typeSafeMatCellDef="let row; dataSource: dataSource">{{ row.organizationUnit }}</td>
    </ng-container>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'admin.user-management.email' | translate }}</th>
      <td mat-cell *typeSafeMatCellDef="let row; dataSource: dataSource">{{ row.mail }}</td>
    </ng-container>
    <ng-container matColumnDef="createdDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'admin.user-management.created-date' | translate }}</th>
      <td mat-cell *typeSafeMatCellDef="let row; dataSource: dataSource">{{ row.accountCreatedDate | date: 'dd.MM.yyyy HH:mm:ss' }}</td>
    </ng-container>
    <ng-container matColumnDef="lastLogin">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'admin.user-management.last-activity' | translate }}</th>
      <td mat-cell *typeSafeMatCellDef="let row; dataSource: dataSource">
        {{ row.lastSuccessfulLoginDate | date: 'dd.MM.yyyy HH:mm:ss' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="isActive">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'admin.user-management.is-active' | translate }}</th>
      <td mat-cell *typeSafeMatCellDef="let row; dataSource: dataSource">{{ (row.isActive ? 'shared.yes' : 'shared.no') | translate }}</td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *typeSafeMatCellDef="let row; dataSource: dataSource">
        <a mat-icon-button [routerLink]="['/', 'users', row.id]"><mat-icon svgIcon="edit_icon" /></a>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *typeSafeMatRowDef="let row; columns: displayedColumns; dataSource: dataSource"
      [ngClass]="{ 'inactive-item': !row.isActive }"
    ></tr>
  </table>
</app-table-container>

<mat-paginator [pageSizeOptions]="[50, 100, 500, 1000, 5000]" />
